import React, { useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import {
  WContainer,
  Breadcrumbs,
  MainTitle,
  MainDescription,
  Button,
} from '@next-nx/shared-ui/atoms'
import { Page, CopertinaBox } from '@next-nx/shared-ui/organisms'
import styles from './ComunicatiListingTemplate.module.sass'
import ComunicatoCard from '../../molecules/ComunicatoCard/ComunicatoCard'
import { COMUNICATI_LISTING_ITEMS_PER_PAGE } from '@next-nx/utils/settings'

interface Props {
  className?: string
  pagina?: any
  allComunicati: any
}

const ComunicatiListingTemplate = (props: Props) => {
  const { pagina = {}, allComunicati = undefined } = props

  const comunicatiMenu = useFindMenu('pagina-comunicati')
  const BoxComunicati = useFindMenu('box-comunicati', comunicatiMenu)
  const t = useTrans()

  const [numItems, setNumItems] = useState(COMUNICATI_LISTING_ITEMS_PER_PAGE)
  const comunicatiToShow = allComunicati?.allComunicati.edges.filter((n, i) => i < numItems)

  return allComunicati && allComunicati.allComunicati ? (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
        <div className={styles.listing}>
          {allComunicati.allComunicati.edges
            .filter((n, i) => i < numItems)
            .map(
              (n) =>
                n?.node && (
                  <div className={styles.item} key={n.node.pk}>
                    <ComunicatoCard comunicato={n?.node} />
                  </div>
                )
            )}
        </div>
        <div className={styles.ordinamenti}>
          <p>
            Hai visualizzato {comunicatiToShow.length} articoli di{' '}
            {allComunicati.allComunicati.edges.length}
          </p>
          {numItems < allComunicati.allComunicati.edges.length && (
            <Button
              onClick={() => setNumItems(numItems + COMUNICATI_LISTING_ITEMS_PER_PAGE)}
              label={t('Carica altri')}
              color={'blue'}
            />
          )}
        </div>
      </WContainer>
      {!!BoxComunicati && (
        <CopertinaBox
          className={styles.comunicatoBanner}
          imagePos="right"
          item={BoxComunicati}
        ></CopertinaBox>
      )}
    </Page>
  ) : (
    <></>
  )
}

export default ComunicatiListingTemplate
